/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';
import Switch from "react-switch";

import { useTextMessage } from '@fitinsur/hooks';
import Colors from "constants/Colors";
import Icon from "components/Icon";

import * as S from './styles';

export function ListActions({
  viewRoute,
  editRoute,
  setShowModalConfirmationClone,
  setShowModalConfirmationExpire,
  expired
}) {
  const { getDescription } = useTextMessage();


  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', width: "100px", gap: "2px" }}>
        {viewRoute && (
          <S.IconContainer expired={expired}>
            <Icon
              name="openEye"
              title={getDescription("DOMAINS", 863)}
              onClick={() => viewRoute()}
            />
          </S.IconContainer>
        )}

        {editRoute && (
          <S.IconContainer expired={expired}>
            <Icon
              name="edit"
              title={getDescription("DOMAINS", 864)}
              onClick={() => editRoute()}
            />
          </S.IconContainer>
        )}

        {setShowModalConfirmationClone && (
          <S.IconContainer expired={expired}>
            <Icon
              name="copy"
              title={getDescription("DOMAINS", 865)}
              onClick={() => setShowModalConfirmationClone()}
            />
          </S.IconContainer>
        )}

        {setShowModalConfirmationExpire && (
          <span title={expired ? getDescription("DOMAINS", 867) : getDescription("DOMAINS", 866)}>
            <Switch
              checked={!expired}
              onChange={() => setShowModalConfirmationExpire()}
              height={15}
              width={30}
              handleDiameter={11}
              checkedIcon={false}
              uncheckedIcon={false}
              offColor={Colors.GRAY[4]}
              onColor={Colors.GRAY[6] || Colors.GREEN}
              offHandleColor={!expired ? Colors.DANGER : Colors.GRAY[6]}
              onHandleColor={Colors.WHITE}
            />
          </span>
        )}
      </div>
    </div>
  )
}
